module.exports = __webpack_public_path__ + "fonts/SegoeUI.930366d9.woff";